import YesNoPrompt from "components/modals/prompts/yesNoPrompt";
import {
    ATTACHMENT_LEVEL,
    ATTACHMENT_RECIPIENTS,
} from "constants/generalConstants";
import useAttachments from "hooks/useAttachments";
import { useDispatch, useSelector } from "react-redux";
import { eliminateAttachmentByFileId } from "services/attachment/attachmentAPIs";

import AttachmentTable from "./attachmentTable";

const { Button, Box, Typography } = require("@mui/material");
const { default: React, useState } = require("react");

const HeaderAttachmentsReview = () => {
    const { headerAttachments, deleteAttachment } = useAttachments();
    const isPostPoReq = useSelector(
        (state) => state.createRequisition.isPostPoReq
    );

    const [openDeletePopup, setOpenDeletePopup] = useState(false);

    const dispatch = useDispatch();

    const handleDeleteButtonClick = () => {
        setOpenDeletePopup(true);
    };

    const handleConfirmDeleteNo = () => {
        setOpenDeletePopup(false);
    };

    // Checks if any attachment is selected for deletion
    const hasAnyAttachmentSelected = () => {
        const selectedAttachmentsCount = headerAttachments.filter(
            (attachment) => attachment.isSelectedToDelete === true
        ).length;

        return (
            selectedAttachmentsCount !== headerAttachments.length &&
            selectedAttachmentsCount !== 0
        );
    };

    const handleConfirmDeleteYes = async () => {
        setOpenDeletePopup(false);

        // Delete all attachments if none is selected
        let selectedAttachmentsToDelete = headerAttachments;
        if (hasAnyAttachmentSelected()) {
            selectedAttachmentsToDelete = headerAttachments.filter(
                (attachment) => attachment.isSelectedToDelete === true
            );
        }

        selectedAttachmentsToDelete = selectedAttachmentsToDelete.filter(
            (a) => (isPostPoReq && a.isNewUpload) || !isPostPoReq
        );

        selectedAttachmentsToDelete.forEach(async (attachment) => {
            await deleteAttachment(attachment, dispatch);
        });
    };

    const hasHeaderAttachments = headerAttachments?.length > 0;

    if (!hasHeaderAttachments) {
        return (
            <Typography align="center">
                No attachments in requisition header.
            </Typography>
        );
    }
    return (
        <>
            {!isPostPoReq && (
                <Box sx={{ paddingBottom: 2 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        color="info"
                        disabled={!hasHeaderAttachments}
                        onClick={handleDeleteButtonClick}
                    >
                        {hasAnyAttachmentSelected()
                            ? "Delete selected header attachments"
                            : "Delete all header attachments"}
                    </Button>
                </Box>
            )}
            <AttachmentTable
                attachments={headerAttachments ?? []}
                lineOrheader="HEADER"
            />
            <YesNoPrompt
                title="Delete Confirmation"
                subtitle={
                    hasAnyAttachmentSelected()
                        ? "Are you sure you want to delete selected attachments from the requisition header?"
                        : "Are you sure you want to delete all attachments from the requisition header?"
                }
                promptOpen={openDeletePopup}
                setPromptOpen={handleConfirmDeleteNo}
                onClickYes={() => {
                    handleConfirmDeleteYes();
                }}
            />
        </>
    );
};

export default HeaderAttachmentsReview;
